import axios from "axios";

const API = process.env.REACT_APP_BACKEND_URL;

export function trackPageView(page) {
  axios.post(`${API}/api/track/pageview`, { page }).catch(() => {});
}

export function trackRepSelect(count, constituency) {
  axios.post(`${API}/api/track/rep-select`, { count, constituency }).catch(() => {});
}
